import country from '../../../structuredData/types/country';
import imageObject from '../../../structuredData/types/imageObject';
export default {
  name: 'Natu.Care',
  url: 'https://natu.care/pl',
  logo: imageObject({
    id: 'https://natu.care/pl/#logo',
    caption: 'Natu.Care',
    url: 'https://natu.care/images/favicon-196x196.png'
  }),
  address: {
    streetAddress: 'Okopowa 58/72',
    addressLocality: 'Warszawa',
    addressRegion: 'mazowieckie',
    addressCountry: country({
      name: 'PL'
    }),
    postalCode: '01-042'
  },
  founder: [{
    givenName: 'Natalia',
    familyName: 'Grajcar'
  }],
  publishingPrinciples: 'https://natu.care/pl/o-nas/proces-redakcyjny',
  knowsLanguage: ['https://www.wikidata.org/wiki/Q1860', 'https://www.wikidata.org/wiki/Q809'],
  knowsAbout: ['https://www.wikidata.org/wiki/Q368344', 'https://www.wikidata.org/wiki/Q4519653', 'https://www.wikidata.org/wiki/Q645858', 'https://www.wikidata.org/wiki/Q1779264', 'https://www.google.com/search?kgmid=/m/0kt51'],
  keywords: ['suplementy diety', 'kolagen, zdrowie, uroda', 'dieta', 'odżywianie'],
  alternateName: ['NatuCare', 'Natu Care'],
  vatID: 'PL5273010336',
  taxID: '5273010336',
  sameAs: ['https://www.facebook.com/100083714082839', 'https://www.instagram.com/natucare_pl/', 'https://www.tiktok.com/@natu.care', 'https://www.youtube.com/channel/UCio8DcT_TAZDlruVG4HOl9g', 'https://linktr.ee/natu.care', 'https://natu.care/pl', 'https://natu.care', 'https://shop.natu.care', 'https://natu.shop', 'https://www.biznes.gov.pl/pl/wyszukiwarka-firm/wpis/krs/0000981162', 'https://muckrack.com/media-outlet/natu-1', 'https://allegro.pl/uzytkownik/natu_care', 'https://www.ekomi-pl.com/opinie-natu.care.pl.html'],
  legalName: 'Natu Care sp. z o.o.',
  foundingDate: '2022',
  foundingLocation: {
    address: {
      addressLocality: 'Warszawa',
      addressCountry: country({
        name: 'PL'
      }),
      addressRegion: 'mazowieckie'
    }
  },
  merchantReturnPolicy: {
    merchantReturnLink: 'https://natu.care/pl/regulamin#prawo_odstapienia_od_umowy'
  },
  contactPoint: {
    contactType: 'customer service',
    email: 'kontakt@natu.care',
    url: 'https://natu.care/pl/kontakt'
  },
  slogan: 'Z troską, naturalnie.',
  description: 'Natu.Care to marka health & beauty skupiona na suplementach diety dla zdrowia i urody. Firma prowadzi działalność detaliczną w ecommerce oraz jest wydawcą serwisu online o tematyce zdrowie, uroda i wellness.'
};